module.exports = __webpack_public_path__ + "static/media/buy3.28821ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy/buy3.png
// module id = 972
// module chunks = 0